import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("sth_token"));
  const [role, setRole] = useState(() => localStorage.getItem("sth_role"));
  const [adminEmail, setAdminEmail] = useState(() => localStorage.getItem("sth_admin_email"));
  const [adminName, setAdminName] = useState(() => localStorage.getItem("sth_admin_name"));

  useEffect(() => {
    if (token) localStorage.setItem("sth_token", token);
    else localStorage.removeItem("sth_token");
    if (role) localStorage.setItem("sth_role", role);
    else localStorage.removeItem("sth_role");
  }, [token, role]);

  const residentLogin = async (pin) => {
    const { data } = await api.post("/auth/resident", { pin });
    setToken(data.token);
    setRole(data.role);
    return data;
  };

  const adminLogin = async (email, pin, remember) => {
    const { data } = await api.post("/auth/admin", { email, pin });
    setToken(data.token);
    setRole(data.role);
    setAdminEmail(data.email);
    setAdminName(data.name);
    localStorage.setItem("sth_admin_email", data.email);
    localStorage.setItem("sth_admin_name", data.name);
    if (remember) {
      localStorage.setItem("sth_remember_email", email);
    } else {
      localStorage.removeItem("sth_remember_email");
    }
    return data;
  };

  const logout = () => {
    setToken(null);
    setRole(null);
    setAdminEmail(null);
    setAdminName(null);
    localStorage.removeItem("sth_token");
    localStorage.removeItem("sth_role");
    localStorage.removeItem("sth_admin_email");
    localStorage.removeItem("sth_admin_name");
  };

  const isAuthed = !!token;
  const isAdmin = role === "admin" || role === "super_admin";
  const isSuper = role === "super_admin";

  return (
    <AuthContext.Provider value={{ token, role, adminEmail, adminName, residentLogin, adminLogin, logout, isAuthed, isAdmin, isSuper }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
